import PropTypes from 'prop-types';
import React from 'react';
import { useAutoId, toEventObject } from './helpers';

Toggle.propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  tag: PropTypes.string,
};
export default function Toggle({
  label,
  disabled = false,
  name,
  value,
  onChange,
  tag = 'span',
}) {
  const autoId = useAutoId('toggle');
  const handleChange = (event) => {
    onChange(toEventObject(name, event.target.checked));
  };

  return React.createElement(
    tag,
    {
      className: 'toggle_cover',
    },
    <>
      <input
        type="checkbox"
        className="lw_toggle"
        id={autoId}
        checked={value}
        onChange={handleChange}
        disabled={disabled}
      />
      <label htmlFor={autoId}>{label}</label>
    </>,
  );
}
